(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Etsy-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.etsy-reviews').forEach(function (section) {
    var track = section.querySelector('.etsy-reviews__track');
    var prev = section.querySelector('.etsy-reviews__nav--prev');
    var next = section.querySelector('.etsy-reviews__nav--next');
    if (!track) return;

    var scrollAmount = function () {
      var card = track.querySelector('.etsy-reviews__card');
      return card ? card.offsetWidth + 22 : 320;
    };

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
